import { createVNode as l, mergeProps as i } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ExportFilled.js";
import m from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return l(m, i(e, {
    icon: p
  }), null);
};
r.displayName = "ExportFilled";
r.inheritAttrs = !1;
export {
  r as default
};
